import { SwiperProps } from 'swiper/react';

export const mainSettings: SwiperProps = {
  slidesPerView: 1,
  observeParents: true,
  observer: true,
  initialSlide: 0,
} 

export const childSettings: SwiperProps = {
  slidesPerView: 1,
  initialSlide: 0,
}